import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import FormAcceptPolicy from "./form/FormAcceptPolicy";
import { Link } from 'react-router-dom'
import smoothscroll from 'smoothscroll-polyfill'
import axios from 'axios'

import {toast, ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import NotFound from '../../../universalyComponents/notFound/NotFound'
import { param } from 'jquery';

let _protocol = window.location.protocol;
let _host = window.location.host;
const params = new URLSearchParams(window.location.search);
let code = params.get('code');
let showForm = false;
let email = '';

const checkShowForm = async (code) => {
		try {
        let data = {
          code: code
        };

				const result = await axios({
					method: 'post',
					url: `${_protocol}//${_host}/api/v1/accept-policy/check-rights/`,
          data: data
				})

				showForm = result.data.success;
        email = result.data.email;

		} catch (e) {
			toast.error('Ошибка загрузки формы')
		}
	}

  checkShowForm(code);

const acceptPolicy = ({ checkDomenNameState, ourRef, captchaSiteKey }) => {
  const [successSend, setSuccessSend] = useState(false)
  smoothscroll.polyfill()
  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])
  if(showForm) {
    return (
      <div className={styles.wrapper} id="form">
        <div className={styles.left}>
          <p>Форма обратной связи</p>
        </div>
        <div className={styles.right}>
          <p className={styles.title}>
            <span>&rarr;</span> Заполните эту форму
          </p>
          <div className={styles.form_block_wrapper}>
            <div className={styles.form_block_wrapper_form}>
              {successSend && (
                <div className={styles.wrapper_total_right_success}>
                  <p className={styles.wrapper_total_right_success_p1}>
                    Данные отправлены!
                  </p>
                  <p>Мы внимательно ознакомимся с информацией.</p>
                </div>
              )}
              {!successSend && <FormAcceptPolicy checkDomenNameState={checkDomenNameState} setSuccessSend={setSuccessSend} email={email} captchaSiteKey={captchaSiteKey} />}
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <NotFound/>
    )
  }
}

export default acceptPolicy
